// extracted by mini-css-extract-plugin
export default {"content":"style_content__x88Hv","checkbox":"style_checkbox__KYaCP"};